var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#ED1C24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3753 7.85938L17.0433 17.6055H13.9769L13.6253 7.85938H17.3753ZM15.5003 22.2148C14.4456 22.2148 13.5863 21.375 13.6058 20.3203C13.5863 19.2852 14.4456 18.4453 15.5003 18.4453C16.4964 18.4453 17.3949 19.2852 17.3949 20.3203C17.3949 21.375 16.4964 22.2148 15.5003 22.2148Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRound);
export default __webpack_public_path__ + "static/media/error-round.22eb54f0b5cd25f8dac3c00270b9b57b.svg";
export { ForwardRef as ReactComponent };